import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Navbar, Nav } from 'react-bootstrap';
import Navgater from "../../components/Navgater";
import { serGetTextNO } from '../../axios';
import { useLocation, useNavigate } from 'react-router-dom';
import langList from '../../utils/languagelist.json';
import { useSelector } from 'react-redux';
import markdownIt from 'markdown-it';

export default function Agreement() {
  const [markdownText, setmarkdownText] = useState('');
  const {lg}=useSelector((state)=>state.language)
  const {state:{str}}=useLocation()

  const {expires}=useSelector((state)=>state.logininfo);

  const md = new markdownIt({ html: true });

  useEffect(() => {
    const fetchData = async () => {
      serGetTextNO({txt:str})
      .then(res =>{
        setmarkdownText(res.data);
      })
      .catch(err =>{
        console.log(err.message);
      });
    };
    fetchData();
  }, [str]);

  const navigate=useNavigate();
  const handleToHomePage=()=>{
    navigate('/',{replace:true});
  };
  const handleToRegisterPage=()=>{
    navigate('/register',{replace:true});
  };
  //markdownText
  return (
    <Container>
      <Row>
        <Col>
          <Navgater/>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          <Navbar bg="transparent" data-bs-theme="light">
            <Nav className="me-auto">
              <Nav.Link onClick={handleToHomePage}>
                {langList.agreement1[lg]}
              </Nav.Link>
              {!(expires>Date.now()) && 
              <Nav.Link onClick={handleToRegisterPage}>
                {langList.agreement3[lg]}
              </Nav.Link>
              }
            </Nav>
          </Navbar>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          <div dangerouslySetInnerHTML={{ __html: md.render(markdownText) }} />
        </Col>
      </Row>
    </Container>
  )
}
